import React from "react";
import LogoLight2x from "../../images/logo2x.png";
import LogoDark2x from "../../images/logo-dark2x.png";
import {Link} from "react-router-dom";
import '../../pages/pages.css';

const Logo = () => {
  return (
    <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link d-block mx-auto w-100">
      <img className="logo-light logo-img" src={LogoLight2x} alt="logo" />
      <img className="logo-dark logo-img logo" src={LogoDark2x} alt="logo" />
    </Link>
  );
};

export default Logo;
